import React from "react";

const PolicyPage: React.FC = () => {
  return <div>PolicyPage</div>;
};

export default PolicyPage;
